import { useState, useEffect } from "react";
import locationActive from "assets/icons/location-active.png";
import locationInactive from "assets/icons/location.png";

interface MapMarkerProps {
  position: google.maps.LatLngLiteral;
  content: string;
  map: google.maps.Map | undefined;
  active: boolean;
  currentIndex: number | undefined;
  setActiveIndex?: (index: number) => void;
}

function MapMarker({
  position,
  content,
  map,
  active,
  currentIndex,
  setActiveIndex,
}: MapMarkerProps) {
  const [infoWindowOpen, setInfoWindowOpen] = useState(false);
  const [infoWindow, setInfoWindow] = useState<google.maps.InfoWindow | null>(
    null
  );
  const [marker, setMarker] = useState<google.maps.Marker | null>(null);

  const activeIcon = {
    url: locationActive,
    scaledSize: new google.maps.Size(50, 50),
  };

  const inactiveIcon = {
    ...activeIcon,
    url: locationInactive,
  };

  const handleMarkerClick = (infoWindowInstance: google.maps.InfoWindow) => {
    infoWindowInstance.close();
    currentIndex && setActiveIndex && setActiveIndex(currentIndex);
  };

  useEffect(() => {
    const infoWindowInstance = new window.google.maps.InfoWindow({
      content: content,
    });

    const markerInstance = new window.google.maps.Marker({
      position: position,
      map: map,
      icon: inactiveIcon,
    });

    markerInstance.addListener("click", () =>
      handleMarkerClick(infoWindowInstance)
    );

    if (active) {
      markerInstance.setIcon(activeIcon);
    } else {
      markerInstance.setIcon(inactiveIcon);
    }

    setInfoWindow(infoWindowInstance);
    setInfoWindowOpen(active);
    setMarker(markerInstance);

    if (map) {
      google.maps.event.addListener(map, "click", function () {
        infoWindowInstance.close();
        markerInstance.setIcon(inactiveIcon);
      });
    }
    return () => {
      markerInstance.setMap(null);
    };
  }, [active]);

  useEffect(() => {
    if (infoWindow && marker) {
      if (infoWindowOpen) {
        infoWindow.setContent(content);
        infoWindow.open(map, marker);
      } else {
        infoWindow.close();
      }
    }
  }, [infoWindowOpen]);

  return null;
}

export default MapMarker;
